import styled from "styled-components";

import color from "../../../../constants/color";
import materialUI from "../../../../material-UI";

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const WhiteBg = styled.div`
  position: absolute;
  background: #fff;
  left: 9px;
  top: 50%;
  width: 80%;
  height: 90%;
  transform: translateY(-50%);
  pointer-events: none;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  width: 100%;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${color.primary} !important;
    }
  }
  .MuiOutlinedInput-input {
    padding-top: 10.5px;
    padding-bottom: 10.5px;
  }
`;
export const OutlinedInput = styled(materialUI.OutlinedInput)`
  width: 100%;
  border-radius: 8px;

  .MuiSelect-select {
    padding: 0;
    height: 44px;
    padding-left: 24px;
    padding-top: 10px;
  }

  fieldset {
    height: 44px;
  }

  &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${color.primary} !important;
  }

  legend {
    span {
      display: none;
    }
  }
`;

export const LabelText = styled.span`
  display: block;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;
`;

export const HeaderModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px;
`;

export const HeaderModalTitle = styled.p`
  font-family: Roboto;
  font-weight: 400;
  font-size: 34px;
  line-height: 123.5%;
  letter-spacing: 0.25px;
  color: ${color.fullBlack};
`;

export const ClearBtn = styled.p`
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${color.primary};
  cursor: pointer;
`;

export const ContentModal = styled.div`
  padding: 32px;
  overflow-y: auto;
  margin-bottom: 110px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: ${color.LigthGrey};
  }
`;

export const LabelModal = styled.p`
  font-family: Inter-Medium;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.01em;
  color: ${color.fullBlack};
  margin-bottom: 11px;
`;

export const RadioGroup = styled(materialUI.RadioGroup)`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: 18px;
`;

export const Checkbox = styled(materialUI.Checkbox)``;

export const FormControlLabel = styled(materialUI.FormControlLabel)`
  .MuiTypography-body1 {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${color.grey1};
  }
  &.switch-control {
    margin: 12px 0px;
    .MuiSwitch-root {
      margin-left: -2px;
    }
    .MuiTypography-body1 {
      font-family: Inter-Medium;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: -0.01em;
      color: ${color.grey1};
      margin-top: 5px;
    }
  }
`;

export const Radio = styled(materialUI.Radio)``;

export const DesktopDatePicker = styled(materialUI.DesktopDatePicker)`
  .Mui-disabled {
    background-color: rgb(242, 244, 248);
  }
`;

export const LocalizationProvider = styled(materialUI.LocalizationProvider)`
  display: flex;
  align-items: center;
`;

export const ContentDate = styled.div`
  width: 50%;

  &:first-of-type {
    margin-right: 8px;
  }
`;

export const Switch = styled(materialUI.Switch)`
  .MuiSwitch-switchBase {
    bottom: -1px;
    top: unset;
    left: 5px;
  }
  .MuiSwitch-switchBase.Mui-checked {
    transform: translateX(14px);
  }
  .MuiSwitch-thumb {
    width: 16px;
    height: 16px;
  }
  .MuiSwitch-track {
    width: 36px;
    height: 20px;
    border-radius: 12px;
    background-color: #a3a3a6;
  }
  .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
    opacity: 1;
  }
  .MuiSwitch-colorSecondary.Mui-checked {
    color: ${color.White};
  }
`;

export const FormTag = styled(materialUI.ToggleButtonGroup)`
  width: 100%;
`;

export const LabelTag = styled(materialUI.ToggleButton)`
  height: 24px;
  background: #ececec !important;
  border-radius: 16px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px !important;
  line-height: 16px !important;
  letter-spacing: -0.01em;
  color: #424248;
  text-transform: capitalize !important;
  padding: 0 8px !important;
  margin-right: 6px !important;
  border: none !important;
  transition: all 0.2s;

  &.Mui-selected {
    color: ${color.White}!important;
    background: ${color.primary}!important;
  }
`;

export const Autocomplete = styled(materialUI.Autocomplete)`
  .MuiOutlinedInput-root {
    fieldset {
      border-radius: 8px;
    }
  }

  .MuiInputBase-input {
    padding: 0 !important;
  }

  .Mui-focused {
    fieldset {
      border-color: ${color.primary} !important;
    }
  }
  .Mui-disabled {
    background-color: rgb(242, 244, 248);
  }
`;

export const FooterModal = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
  padding: 24px;
  border-top: 1px solid ${color.LigthGrey};
  width: 100%;
`;

export const Button = styled(materialUI.Button)`
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  border-radius: 8px;
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.01em;
  font-family: Inter-Medium;
  color: ${color.White};
  text-transform: capitalize;
  padding: 16px;
`;

export const TextCenter = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.05em;
  color: #757575;
  margin: 0px 6px;
`;
